export default __webpack_public_path__ + "static/media/versus-removebg-preview.591fa84e.jpg";